/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Ad_CcprjInputs */



/**
* | output |
* | --- |
* | "Import AD Project" |
*
* @param {Import_Ad_CcprjInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const import_ad_ccprj = /** @type {((inputs?: Import_Ad_CcprjInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Ad_CcprjInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Projet d'importation AD")
	if (locale === "de") return /** @type {LocalizedString} */ ("AD-Projekt importieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa progetto AD")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт проекта AD")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importar proyecto AD")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导入 AD 项目")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ADプロジェクトをインポートする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("AD प्रोजेक्ट आयात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Projeto de Importação de Anúncios")
	return /** @type {LocalizedString} */ ("Import AD Project")
});